import { useMutation } from '@apollo/client';
import { FormikProvider, useFormik } from 'formik';
import { REQUEST_MAGIC_LINK_MUTATION } from 'lib/mutations';
import { useEffect } from 'react';
import useNotification from 'src/hooks/useNotification';
import { Button } from 'src/shared-components';
import { InputField } from 'src/shared-components/Form';
import * as Yup from 'yup';

const FormMagicLinkRequest = ({ onRequestSent }: { onRequestSent: (magicLinkSent: boolean) => void }) => {
  const [requestMagicLink, { error }] = useMutation<any>(REQUEST_MAGIC_LINK_MUTATION);
  const { showError, hideNotification } = useNotification();

  const form = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email().required('Hey we need an email to send the magic link to.'),
    }),
    onSubmit: async values => {
      try {
        const { data } = await requestMagicLink({
          variables: {
            input: values.email,
          },
        });
        onRequestSent(data.magicLink);
      } catch (error: any) {
        showError({ title: 'Cannot request magic link', description: error.message });
      }
    },
  });

  // TODO: Improve this, modify the provider in order to not have to put this in the component
  useEffect(() => {
    return () => {
      hideNotification();
    };
  }, []);

  if (error) {
    console.error(error.message);
  }

  return (
    <FormikProvider value={form}>
      <div className="grid grid-cols-6 gap-4">
        <div className="col-span-6">
          <InputField
            type="email"
            name="email"
            autoComplete="off"
            label="Email address"
            placeholder="Email address"
            required
          />
        </div>
        <div className="col-span-6 mt-2">
          <Button
            data-testid="requesPasswordButton"
            size="lg"
            roundness="md"
            color="primary"
            fullWidth
            onClick={() => form.submitForm()}
          >
            Request Magic Link
          </Button>
        </div>
      </div>
    </FormikProvider>
  );
};

export default FormMagicLinkRequest;
